export default {
  "site.name": "Kakobuy Spreadsheet Polska",
  "site.tagline": "Najlepszy przewodnik zakupowy",

  "nav.home": "Strona główna",
  "nav.categories": "Kategorie",
  "nav.guide": "Poradnik",
  "nav.article": "Artykuł",
  "nav.safety": "Bezpieczeństwo",

  "hero.title": "Kakobuy Spreadsheet Polska – Znajdź najlepsze produkty szybciej",
  "hero.subtitle": "Kakobuy Spreadsheet to najprostszy sposób na odkrywanie popularnych produktów, sneakersów, ubrań streetwear oraz najlepszych okazji zakupowych.",
  "hero.cta.primary": "Przeglądaj Kakobuy Spreadsheet",
  "hero.cta.secondary": "Jak działa Kakobuy?",
  "hero.trust.1": "Aktualne listy produktów",
  "hero.trust.2": "Kategorie produktów",
  "hero.trust.3": "Poradniki dla początkujących",
  "hero.trust.4": "Bezpieczne zakupy",

  "whatis.title": "Czym jest Kakobuy Spreadsheet?",
  "whatis.content": "Kakobuy Spreadsheet to uporządkowana baza produktów, która pomaga użytkownikom znaleźć popularne produkty z chińskich marketplace takich jak Taobao, Weidian i 1688. Zamiast spędzać godziny na przeszukiwaniu setek stron, otrzymujesz gotową listę sprawdzonych i popularnych produktów w jednym miejscu.",
  "whatis.table.header1": "Metoda",
  "whatis.table.header2": "Czas wyszukiwania",
  "whatis.table.header3": "Łatwość",
  "whatis.table.row1.col1": "Kakobuy Spreadsheet",
  "whatis.table.row1.col3": "Bardzo łatwo",
  "whatis.table.row2.col1": "Samodzielne szukanie",
  "whatis.table.row2.col3": "Trudno",
  "whatis.table.row3.col1": "Losowe linki",
  "whatis.table.row3.col3": "Ryzyko",

  "categories.title": "Najpopularniejsze kategorie Kakobuy Spreadsheet",
  "categories.dropdown.label": "Wybierz kategorię",

  "benefits.title": "Dlaczego użytkownicy wybierają Kakobuy Spreadsheet?",
  "benefits.card1.title": "Oszczędność czasu",
  "benefits.card1.desc": "Gotowe listy produktów zamiast godzin wyszukiwania na chińskich platformach.",
  "benefits.card2.title": "Lepsze wybory",
  "benefits.card2.desc": "Porównuj produkty przed zakupem i wybieraj tylko sprawdzone okazje.",
  "benefits.card3.title": "Aktualne trendy",
  "benefits.card3.desc": "Znajduj najpopularniejsze produkty i bądź na bieżąco z najnowszymi trendami.",

  "steps.title": "Jak działa Kakobuy Spreadsheet?",
  "steps.step1.title": "Znajdź produkt",
  "steps.step1.desc": "Przeglądaj kategorie i wybierz interesujący Cię produkt z listy.",
  "steps.step2.title": "Sprawdź informacje",
  "steps.step2.desc": "Zapoznaj się ze szczegółami produktu, zdjęciami i opiniami.",
  "steps.step3.title": "Porównaj opcje",
  "steps.step3.desc": "Porównaj podobne produkty i wybierz najlepszą ofertę.",
  "steps.step4.title": "Przejdź do zakupu",
  "steps.step4.desc": "Kliknij link i przejdź bezpośrednio do strony produktu.",

  "safety.title": "Bezpieczeństwo zakupów",
  "safety.intro": "Kakobuy Spreadsheet pomaga znaleźć produkty, ale zawsze sprawdzaj sprzedawcę, opinie oraz informacje dotyczące zakupu. Oto na co zwrócić uwagę:",
  "safety.table.header1": "Element",
  "safety.table.header2": "Co sprawdzić",
  "safety.table.row1.col1": "Ocena sprzedawcy",
  "safety.table.row1.col2": "Sprawdź rating i historię sprzedawcy przed zakupem",
  "safety.table.row2.col1": "Zdjęcia QC",
  "safety.table.row2.col2": "Zawsze proś o zdjęcia jakości przed wysyłką",
  "safety.table.row3.col1": "Cena",
  "safety.table.row3.col2": "Porównaj cenę z podobnymi produktami na rynku",
  "safety.table.row4.col1": "Opinie",
  "safety.table.row4.col2": "Czytaj doświadczenia innych kupujących",

  "faq.title": "Najczęściej zadawane pytania",
  "faq.q1": "Co to jest Kakobuy Spreadsheet?",
  "faq.a1": "Kakobuy Spreadsheet to uporządkowana lista produktów z chińskich marketplace, która pomaga użytkownikom szybko znaleźć popularne i sprawdzone produkty bez konieczności wielogodzinnego przeszukiwania platform takich jak Taobay, Weidian czy 1688.",
  "faq.q2": "Czy Kakobuy Spreadsheet działa w Polsce?",
  "faq.a2": "Tak, Kakobuy Spreadsheet jest dostępny dla użytkowników w Polsce. Produkty można przeglądać z Polski, a zamówienia są wysyłane międzynarodowo. Warto zapoznać się z zasadami dotyczącymi cła i wysyłki do Polski.",
  "faq.q3": "Czy Kakobuy jest bezpieczny?",
  "faq.a3": "Kakobuy jako platforma pośrednicząca oferuje dodatkową warstwę bezpieczeństwa. Zawsze jednak zalecamy sprawdzanie ocen sprzedawców, czytanie opinii innych użytkowników oraz korzystanie ze zdjęć QC przed finalizacją zamówienia.",
  "faq.q4": "Jak znaleźć najlepsze produkty w Kakobuy Spreadsheet?",
  "faq.a4": "Najlepsze produkty znajdziesz przeglądając kategorie, sprawdzając aktualne trendy i popularne listy. Regularnie aktualizujemy nasze rekomendacje, abyś zawsze miał dostęp do najnowszych i najlepszych znalezisk.",

  "article.cta.title": "Chcesz dowiedzieć się więcej?",
  "article.cta.subtitle": "Przeczytaj nasz kompletny przewodnik Kakobuy Spreadsheet – wszystko co musisz wiedzieć w jednym miejscu.",
  "article.cta.button": "Przeczytaj pełny artykuł",

  "footer.copyright": "© 2026 Kakobuy Spreadsheet Polska. Wszelkie prawa zastrzeżone.",
  "footer.disclaimer": "Ta strona jest niezależnym przewodnikiem i nie jest powiązana z Kakobuy. Wszystkie linki prowadzą do zewnętrznych stron.",

  "buy.now": "Kup teraz",
  "kakobuy.spreadsheet": "Kakobuy Spreadsheet",
}